module.exports = __webpack_public_path__ + "img/logo_red.daf8fde8.svg";